import { defineGameCard, heatsUp, ongoing } from '../authoring/index.js';
export const MeltdownCoreCard = defineGameCard({
    id: 'meltdown_core',
    gameplay: { type: 'UNIT', cost: 6, baseStats: { attack: 8, health: 7 } },
    presentation: {
        name: 'Ядро расплава',
        description: 'Греется. Получает +1 к атаке за каждый Перегрев.',
        glyph: {
            colors: ['#9A7D68', '#CC856F', '#A47E4B'],
            rows: [
                '2312131.2',
                '23.2.12.3',
                '1313..131',
                '2.121.211',
                '312211221',
                '1.33..121',
                '1112111.3',
                '33...2312',
                '211.21.32',
            ],
        },
    },
    role: 'playable',
    abilities: [
        heatsUp(),
        ongoing((ctx) => ctx.self !== undefined && ctx.self.heat > 0
            ? [{
                    abilityId: 'critical_heat_attack',
                    scope: { kind: 'unit', instanceId: ctx.self.id },
                    statMods: [{ stat: 'attack', op: 'add', value: ctx.self.heat }],
                }]
            : []),
    ],
    ui: { mechanics: ['heats_up', 'heat', 'ongoing'] },
});
//# sourceMappingURL=meltdown_core.js.map